import { Fragment, useState } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Iconify from 'src/components/iconify';
import { Box, Divider, IconButton, Modal, Tooltip } from '@mui/material';
import RowProduct from './ProductRow';
import Snte from './subRows/Snte';
import VDebut from './subRows/VDebut';
import VCible from './subRows/VCible';
import ValuesRow from './subRows/ValuesRow';
import SubHeader from './SubHeader';
import { AreaEditMetrics } from 'src/components/Metrics/TextAreaEditMetrics';
import AloneHeader from '../details/AloneHeader';
import TitleMetric from '../TtileMetric';
import NbMetric from './subRows/NbMetric';

export const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80vw',
  height: 'max-content',
  overflow: 'scroll',
  bgcolor: 'background.paper',
  border: '2px solid #eee',
  borderRadius: '10px',
  boxShadow: 24,
  p: 4,
};
const RowEffect = ({ title, isVolet, data }: any) => {
  const [open, setOpen] = useState(false);
  const [openEffect, setOpenEffect] = useState(false);
  const [extraData, setExtraData] = useState('');
  const [targetMetric, setTargetMetric] = useState<any>(undefined);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div key={data?._id}>
      <Accordion
        sx={{
          border: '1px solid #fec002',
          borderRadius: '4px',
          background: '#FFF4E1',
        }}
      >
        <AccordionSummary
          expandIcon={<Iconify icon="ep:arrow-up-bold" className="ml-2" width={16} />}
          sx={{
            flexDirection: 'row-reverse',
            color: '#fec002',
            background: '#FFF4E1',
          }}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <div className="flex w-full items-center justify-between">
            <span>{data.title}</span>
            <IconButton
              size="small"
              color="inherit"
              // className="pt-[-20px]"
              onClick={() => {
                setExtraData(data.extraData || '');
                setOpenEffect(true);
              }}
              sx={{
                p: 0,
                color: 'text.secondary',
                height: '30px',
                width: '30px',
                marginTop: '5px',
              }}
            >
              <Iconify icon="ci:show" width={16} />
            </IconButton>
          </div>
        </AccordionSummary>
        <AccordionDetails sx={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
          <SubHeader title={title} />

          {data.children.map((v: any, index: number) => (
            <Fragment key={v._id}>
              <div key={v._id} className="flex gap-1">
                <div className="flex items-center justify-center flex-col min-w-[50px] w-[50px] text-thin text-xs border-r-2">
                  {/* <span>{isVolet ? v.nbV : v.nb}</span> */}
                  <NbMetric id={v._id} isVolet={isVolet} initialData={isVolet ? v.nbV : v.nb} />
                </div>
                {/* <Tooltip title={isVolet ? v.titleV : v.title}> */}
                <div className=" text-thin text-xs  w-[270px] border-r-2">
                  {/* {isVolet ? v.titleV : v.title} */}
                  <TitleMetric id={v._id} isVolet={isVolet} title={isVolet ? v.titleV : v.title} />
                </div>
                {/* </Tooltip> */}
                <Snte id={v._id} initialData={v.snte} />
                <VDebut id={v._id} data={v.startv} />
                <VCible id={v._id} data={v.ciblev} />
                <ValuesRow id={v._id} data={v} />
                <IconButton
                  size="small"
                  color="inherit"
                  onClick={() => {
                    setTargetMetric(v);
                    handleOpen();
                  }}
                  sx={{
                    p: 0,
                    color: 'text.secondary',
                    height: '30px',
                    width: '30px',
                    marginTop: '5px',
                  }}
                >
                  <Iconify icon="ci:show" width={16} />
                </IconButton>
              </div>
              <Divider />
            </Fragment>
          ))}
          {data.products.map((p: any, i: number) => (
            <RowProduct title={title} isVolet={isVolet} key={i} data={p} />
          ))}
        </AccordionDetails>
      </Accordion>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="w-full overflow-scroll flex flex-col items-center justify-center">
            <Box className="flex flex-col w-full">
              <AloneHeader isIndicateur={true} isVolet={isVolet} />

              <div className="flex w-[max-content] min-h-[140px] h-[max-content]">
                <div className="w-[80px]   border-r-2 flex items-center justify-center text-md font-bold">
                  <AreaEditMetrics data={targetMetric} keys={isVolet ? 'voletv' : 'voletp'} />
                </div>

                <div className="w-[80px] border-r-2 flex items-center justify-center text-md font-bold">
                  <AreaEditMetrics data={targetMetric} keys={isVolet ? 'nbExtraV' : 'nbExtra'} />
                </div>
                <div
                  style={{
                    width: isVolet ? '250px' : '250px',
                  }}
                  className="font-bold border-r-2 flex-col pl-[2px] flex items-center justify-center text-md "
                >
                  <AreaEditMetrics
                    data={targetMetric}
                    keys={isVolet ? 'indicProgV' : 'indicProg'}
                  />{' '}
                </div>
                <div className="w-[800px] flex-col  border-r-2 pl-[2px] flex items-center justify-center text-md">
                  <AreaEditMetrics
                    data={targetMetric}
                    keys={isVolet ? 'contribSntev' : 'contribSnte'}
                  />
                </div>
                <div className="w-[250px] font-bold border-r-2 flex-col pl-[2px] flex items-center justify-center text-md ">
                  <AreaEditMetrics data={targetMetric} keys={isVolet ? 'sourceV' : 'source'} />
                </div>
              </div>
            </Box>
          </div>
        </Box>
      </Modal>

      <Modal
        open={openEffect}
        onClose={() => setOpenEffect(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="w-full  overflow-scroll flex flex-col items-center justify-center">
            <Box className="flex h-[max-content] flex-col w-[max-content]">
              <AloneHeader isVolet={isVolet} />

              <div className="flex w-[max-content] bg-[#FFF3E1] h-[max-content]">
                {/* <div className="w-[120px] h-full flex items-center justify-center text-xs capitalize"></div> */}
                {/* <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize"></div> */}
                {/* <div className="w-[220px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div> */}
                {/* <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div> */}
                {/* <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div> */}
                <div className="w-full  px-[5px]  h-full min-h-[40px] flex items-center justify-center text-md two-line-truncate capitalize-first">
                  <span className="break-words w-[1100px]  text-wrap">{extraData}</span>
                </div>
              </div>
            </Box>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default RowEffect;
